import { EcgMeasures } from '../models/ecgmeasures';
import { ICaliperViewModel, IEcgMeasures, IMeasuresViewModel } from '../models/interfaces';

export class MeasuresViewModel implements IMeasuresViewModel {
    // data members

    selected: boolean = false;
    measures: IEcgMeasures;

    constructor(caliper: ICaliperViewModel, measures: IEcgMeasures | null = null) {
        this._caliper = caliper;
        this.measures = measures == null ? new EcgMeasures() : measures;
    }

    private _caliper: ICaliperViewModel;

    // constructor

    get caliper() {
        return this._caliper;
    }
}
